import React from "react";

import Navbar from "./Navbar";
import Footer from "./Footer";

import FeaturesSection from "./sections/FeaturesSection";
import AttendanceShowcase from "./sections/AttendanceShowcase";
import PayrollShowcase from "./sections/PayrollShowcase";
import PremiumModulesCard from "./sections/PremiumModulesCard";

import "./styles/FeaturesPage.css";

const FeaturesPage = () => {
  return (

    <div className="features-page-wrapper">

      {/* <Navbar /> */}

     
      {/* FEATURES */}

      <FeaturesSection />
      {/* <AttendanceShowcase /> */}
      {/* <PayrollShowcase /> */}
      {/* <PremiumModulesCard /> */}

      {/* <Footer /> */}

    </div>

  );
};

export default FeaturesPage;















